import React, { PureComponent } from "react";
import { Picker } from "@ss/mtd-react3";
import { fetchData } from "@/utils";
import urls from "@/urls";

class DirectoryPicker extends PureComponent {
    state = {
        directoryList: [],
        loading: false
    };

    componentDidMount() {
        this.getDirectoryList();
    }

    // 获取并处理目录数据
    getDirectoryList = async () => {
        try {
            const { activeTab } = this.props;
            let url;

            // 根据 activeTab 选择对应的接口
            switch (activeTab) {
                case "1":
                    url = urls.brandAggregation;
                    break;
                case "2":
                    url = urls.InAppSpecs;
                    break;
                case "3":
                    url = urls.brandDesign;
                    break;
                default:
                    url = urls.brandAggregation;
            }
            this.setState({ loading: true });
            const isInner =
                window.location.href.indexOf("assets-internal") > -1;
            const data = await fetchData(
                isInner
                    ? url.catalogue.getCatalogue
                    : url.catalogueOuter.getCatalogue
            );

            // 处理数据格式
            const treeData = this.convertToTree(
                activeTab === "2" ? data.directoryList : data
            );

            // 添加 "All" 选项
            const finalList = [{ value: "all", label: "All" }, ...treeData];

            this.setState({
                directoryList: finalList,
                loading: false
            });
        } catch (error) {
            console.error("获取目录列表失败:", error);
            this.setState({ loading: false });
        }
    };
    // 转换为树形结构
    convertToTree = data => {
        const list = [];

        // 遍历数据构建树形结构
        for (const item of data) {
            // 转换格式
            const treeItem = {
                value: item.directoryId,
                label: item.directoryName
            };

            const { directoryParentId } = item;
            const parentDirectory = data.find(
                directory => String(directory.directoryId) === directoryParentId
            );

            if (parentDirectory) {
                if (!parentDirectory.children) {
                    parentDirectory.children = [];
                }
                parentDirectory.children.push(treeItem);
            }

            if (item.directoryLevel === 1) {
                list.push(treeItem);
            }
        }
        console.log(list, "list 111");

        return list;
    };
    render() {
        const { directoryList, loading } = this.state;
        const { value, onChange, style, className } = this.props;

        return (
            <Picker
                value={value}
                options={directoryList}
                onChange={onChange}
                style={{ ...style }}
                className={className}
                placeholder="Type"
                loading={loading}
            />
        );
    }
}

export default DirectoryPicker;
